import { render, staticRenderFns } from "./BankingFiles.vue?vue&type=template&id=11189367&"
import script from "./BankingFiles.vue?vue&type=script&lang=ts&"
export * from "./BankingFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports